<template>
  <footer class="m-mini-footer">
    <VButton
      class="m-back-top"
      @click="backToTop"
    >
      <span>Back to Top</span>
    </VButton>

    <img
      class="m-logo--gray"
      src="~public/images/logo/logo-gray-small.png"
      loading="lazy"
    >
    <div class="m-mini-footer-age">
      Must be 
      <div class="limit-age">
        {{ $t('LEGAL_AGE') }}<span class="icon-plus">+</span>
      </div>
      <span class="age-line"/>
      Please gamble responsibly.
    </div>
  </footer>
</template>

<script>
import VButton from 'fe-vui/button'
import { backToTop } from '@ms/utils/scroll.js'
import 'base/icons/svg/arrowright-new.svg'

export default {
  name: 'MiniFooter',
  components: {
    VButton
  },
  methods: {
    backToTop
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");
@import url("~wap/common/style/mixin.less");

.m-mini-footer {
  padding: 10px 0 30px;
  background: @dark;
  text-align: center;

  .m-back-top {
    width: 335/375 * 100%;
    border: 1px solid #ffca27;
    border-radius: 22px;
    margin: 0 auto;
    background: transparent;
    color: #ffca27;
    line-height: 42/@rem;
  }

  .m-logo--gray {
    width: 88/375 * 100%;
    margin: 60/@rem auto 0;

    img {
      display: block;
    }
  }
  
  &-age{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    color: #333;
    font-size: 12px;

    .age-line {
      width: 1px;
      height: 10px;
      margin: 0 8px;
      background: #333;
    }

    .limit-age {
      width: 20px;
      height: 20px;
      border: 1px solid #333;
      border-radius: 50%;
      margin-left: 4px;
      font-size: 10px;
      line-height: 20px;
      text-align: center;
      white-space: nowrap;

      .icon-plus {
        display: inline-block;
        font-size: 8px;
        line-height: 22px;
        vertical-align: top;
      }
    }
  }
}
</style>



<style lang="scss" scoped>

  [data-mode="light"] .m-mini-footer{
    background: #f8f8f8;
    
    .m-back-top{
      color: #000;
    }
    
    &-age{
      color: #999;
      
      .limit-age{
        border-color: #999;
      }
    }
  }
</style>

